var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlamesRaffleEnd = function SvgFlamesRaffleEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 165,
    fill: "none",
    viewBox: "0 0 78 165"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_7549_10135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7549_10135)",
    fillOpacity: 0.25,
    fillRule: "evenodd",
    d: "M34.927 9.074c-.475 2.418-2.245 3.17-3.521 3.288-.273.025-.386-.294-.19-.475.666-.614 1.489-1.591 1.691-2.623.218-1.109-.505-2.613-1.112-3.572a.29.29 0 0 0-.526.089c-.194.817-.547 1.892-1.305 2.64a.257.257 0 0 1-.407-.06c-.067-.123-.131-.257-.196-.392a8 8 0 0 0-.216-.429c-.076-.136-.254-.173-.389-.093-.524.314-1.27.816-1.423 1.596-.104.528.002 1.125.157 1.619.085.272-.21.52-.442.34-.958-.742-2.007-2.07-1.662-3.822.205-1.045 1.333-2.15 2.523-3.316.848-.831 1.727-1.693 2.327-2.586.227-.338.739-.417 1.023-.11 1.724 1.859 4.185 5.28 3.668 7.906m30.615 100.323c2.228 1.189 5.945 1.871 9.32-1.592 3.668-3.761 3.29-12.055 2.449-16.98-.14-.814-1.065-1.239-1.802-.928-1.945.818-4.316 1.283-6.602 1.73-3.209.63-6.25 1.225-7.708 2.72-2.447 2.51-2.146 5.83-1.366 8.091.189.546.94.457 1.092-.082.275-.98.74-2.077 1.479-2.834 1.088-1.116 2.855-1.134 4.053-1.081.307.013.561.268.54.574a15 15 0 0 1-.105.94c-.038.291-.076.582-.098.856a.51.51 0 0 0 .606.54c2.048-.408 3.782-1.794 4.977-2.929a.57.57 0 0 1 .962.425c-.031 2.236-.454 5.493-2.002 7.081-1.441 1.478-3.842 2.193-5.598 2.482-.514.085-.672.733-.197.987M13.81 173.959c9.657 1.471 24.167-.897 32.308-18.165 8.843-18.759-2.78-48.968-11.951-66.1-1.514-2.829-5.442-3.182-7.77-1.061-6.14 5.591-14.286 10.434-22.14 15.103-11.022 6.552-21.468 12.762-24.984 20.219-5.9 12.516-.698 24.412 4.96 31.757 1.365 1.772 4.02.456 3.911-1.741-.197-3.992.163-8.666 1.943-12.44 2.624-5.566 9.098-7.96 13.568-9.343 1.147-.355 2.395.254 2.696 1.415.294 1.131.534 2.375.774 3.619.218 1.128.436 2.256.693 3.299a1.938 1.938 0 0 0 2.896 1.2c7.027-4.205 11.693-11.62 14.687-17.396.904-1.744 3.454-1.597 4.059.305 2.646 8.32 5.108 20.938 1.375 28.855-3.474 7.37-11.42 13.18-17.519 16.563-1.787.992-1.565 3.597.494 3.911M15.8 64.313c3.464-1.65 7.665-5.585 6.53-12.864-1.234-7.908-11.635-14.97-18.372-18.411-1.112-.568-2.467.18-2.76 1.366-.772 3.125-2.36 6.452-3.892 9.66-2.15 4.502-4.188 8.768-3.697 11.912.823 5.276 5.121 7.92 8.571 9.016.833.265 1.408-.736.891-1.411-.939-1.227-1.845-2.793-2.094-4.384-.366-2.347 1.216-4.528 2.367-5.948.295-.364.835-.444 1.187-.14.343.294.694.638 1.045.98.318.312.636.623.948.898a.77.77 0 0 0 1.205-.253c1.365-2.879 1.258-6.26.966-8.755-.088-.753.774-1.266 1.387-.793 2.684 2.067 6.25 5.542 6.77 8.88.485 3.106-.826 6.697-2.07 9.11-.364.708.28 1.489 1.018 1.137",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7549_10135",
    x1: 33.5,
    x2: -5,
    y1: 4,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31246",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6200",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_7549_10135",
    width: 182.004,
    height: 254.149,
    x: -63.731,
    y: -39.424,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 20.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7549_10135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_7549_10135",
    result: "shape"
  })))));
};
export default SvgFlamesRaffleEnd;